module.exports = __webpack_public_path__ + "img/afa.e47916cc.png";